import { useQuery } from '@tanstack/react-query';
import type { AssignableMember, SidebarCountsResponse } from '@orion/contracts';
import { api } from '../../lib/api-client.js';

/** Workspace members for "assign to" pickers — rarely changes within a
 * session, so a longer staleTime avoids refetching on every dropdown open. */
export function useAssignableMembersQuery() {
  return useQuery({
    queryKey: ['assignable-members'],
    queryFn: () => api.get<AssignableMember[]>('/me/assignable-members'),
    staleTime: 5 * 60_000,
  });
}

/** Sidebar's Leads/Tasks badges — refetches on navigation (default
 * react-query behaviour, no extra wiring needed since AppShell mounts once
 * per session but each route change re-renders the tree) and on window
 * focus, so the badge doesn't go stale across a long-open tab. */
export function useSidebarCountsQuery() {
  return useQuery({
    queryKey: ['sidebar-counts'],
    queryFn: () => api.get<SidebarCountsResponse>('/me/sidebar-counts'),
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}
